import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {func, object, string} from 'prop-types';
import React, {useCallback, useState} from 'react';
import {useDataTypes} from '../../client.js';

function DataType({sx, value, onChange}) {
  const {data: dataTypes} = useDataTypes();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = !!anchorEl;

  const onButtonClick = useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const onMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const onMenuItemClick = useCallback(
    newValue => {
      onChange(newValue);
      setAnchorEl(null);
    },
    [onChange],
  );

  const label = value || 'All Data Types';
  const color = value ? 'primary' : 'secondary';

  return (
    <Box sx={sx}>
      <Button
        onClick={onButtonClick}
        variant="outlined"
        size="small"
        color={color}
        endIcon={<ArrowDropDownIcon />}
      >
        {label}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={onMenuClose}>
        <MenuItem
          onClick={() => onMenuItemClick('')}
          dense
          sx={{textTransform: 'uppercase'}}
        >
          All Data Types
        </MenuItem>
        {dataTypes &&
          dataTypes.map(d => (
            <MenuItem
              key={d}
              onClick={() => onMenuItemClick(d)}
              dense
              sx={{textTransform: 'uppercase'}}
            >
              {d}
              <ListItemIcon sx={{marginLeft: 2}}>
                {d === value ? <CheckIcon fontSize="small" /> : null}
              </ListItemIcon>
            </MenuItem>
          ))}
      </Menu>
    </Box>
  );
}

DataType.propTypes = {
  sx: object,
  value: string,
  onChange: func.isRequired,
};

export default DataType;
